import { render, staticRenderFns } from "./CurrentVideo.vue?vue&type=template&id=6daa1f97&"
import script from "./CurrentVideo.vue?vue&type=script&lang=js&"
export * from "./CurrentVideo.vue?vue&type=script&lang=js&"
import style0 from "./CurrentVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports